import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { IFinancial } from "../services/financialService";
import { Preferences } from "@capacitor/preferences";

export const FINANCIAL_STORAGE_NAME = "financial-storage";

interface FinancialState {
  financial: IFinancial | null;
  isLoading: boolean;
  isInitialLoaded: boolean;
  lastFetchedAt: number | null;
  setFinancial: (financial: IFinancial) => void;
  setIsLoading: (isLoading: boolean) => void;
  setIsInitialLoaded: (isInitialLoaded: boolean) => void;
  reset: () => void;
}

const capacitorPreferencesStorage = {
  getItem: async (key: string) => {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  setItem: (key: string, value: string) => {
    return Preferences.set({ key, value });
  },
  removeItem: (key: string) => {
    return Preferences.remove({ key });
  },
};

const useFinancialStore = create<FinancialState>()(
  devtools(
    persist(
      (set) => ({
        financial: null,
        isLoading: false,
        isInitialLoaded: false,
        lastFetchedAt: null,
        setFinancial: (financial: IFinancial) =>
          set({ financial, lastFetchedAt: Date.now() }),
        setIsLoading: (isLoading: boolean) => set({ isLoading }),
        setIsInitialLoaded: (isInitialLoaded: boolean) =>
          set({ isInitialLoaded }),
        reset: () => {
          set({
            financial: null,
            isLoading: false,
            isInitialLoaded: false,
            lastFetchedAt: null,
          });
        },
      }),
      {
        name: FINANCIAL_STORAGE_NAME,
        storage: createJSONStorage(() => capacitorPreferencesStorage),
      }
    )
  )
);

export default useFinancialStore;
